import { CommunicareBase } from './CommunicareBase';

export interface IProviderResponse{
    id: string;
    givenName: string;
    middleNames:string;
    familyName: string;
    authoringSystem:string;
    authoringSystemForeignKey: string;
}


let sleep = async (waitTime: number) => new Promise(resolve => setTimeout(resolve, waitTime));
  
class ServiceApiV1 extends CommunicareBase  {
  
   
    async getCurrentProvider( authoringSystem:string,
        authoringSystemForeignKey:string,
       ): Promise<IProviderResponse> {
         
        let [retryCount, retryWaitTime] = [10, 1000];
    
        let data = await this.fetchProviderInfo(authoringSystem, authoringSystemForeignKey, retryCount, retryWaitTime);   
         
        return {
          id: data.id,
          givenName: data.givenName,
          middleNames: data.middleNames,
          authoringSystem: data.authoringSystem,
          authoringSystemForeignKey: data.authoringSystemForeignKey,
        } as IProviderResponse;
      }
    
      private async fetchProviderInfo(
        authoringSystem:string,
        authoringSystemForeignKey:string,
        retryCount: number,
        retryWaitTime: number,
      ): Promise<IProviderResponse> {
        let fetchProviderInfoPromise: Promise<any>|null=null;

        try {
            let path =  `/api/v1/service/${authoringSystem}/${authoringSystemForeignKey}/current-provider`;
            fetchProviderInfoPromise = await this.AsyncGet(path);

            if(!fetchProviderInfoPromise && retryCount) {
                await sleep(retryWaitTime);
                return await this.fetchProviderInfo(authoringSystem, authoringSystemForeignKey, retryCount - 1, retryWaitTime);
            }
            else {
                return await fetchProviderInfoPromise as IProviderResponse;
            }
        } catch (error) {
          if (retryCount) {
            await sleep(retryWaitTime);
            return await  this.fetchProviderInfo(authoringSystem, authoringSystemForeignKey, retryCount - 1, retryWaitTime );
          }
        }
        return await fetchProviderInfoPromise as IProviderResponse;
      }
}

const communicareServiceApi = new ServiceApiV1();

export { communicareServiceApi };